// extracted by css-extract-rspack-plugin
export default {"badge":"badge-kUH973"};